import { CloseOutlined, WarningOutlined, InfoOutlined, CheckCircleOutlined, ExclamationOutlined } from "@ant-design/icons";
import { ReactNode } from "react";
import "./AlertBanner.scss";

export type AlertType = "warning" | "info" | "success" | "error";

interface AlertBannerAction {
  label: string;
  onClick: () => void;
}

interface AlertBannerProps {
  message: string;
  description?: ReactNode;
  type?: AlertType;
  showIcon?: boolean;
  action?: AlertBannerAction;
  onClose?: () => void;
  visible?: boolean;
}

const AlertBanner = ({
  message,
  description,
  type = "info",
  showIcon = true,
  action,
  onClose,
  visible = true,
}: AlertBannerProps) => {
  if (!visible) {
    return null;
  }

  const getIcon = () => {
    if (!showIcon) return null;

    switch (type) {
      case "warning":
        return <WarningOutlined className="alert-banner__icon alert-banner__icon--warning" />;
      case "error":
        return <ExclamationOutlined className="alert-banner__icon alert-banner__icon--error" />;
      case "success":
        return <CheckCircleOutlined className="alert-banner__icon alert-banner__icon--success" />;
      case "info":
      default:
        return <InfoOutlined className="alert-banner__icon alert-banner__icon--info" />;
    }
  };

  return (
    <div className={`alert-banner alert-banner--${type}`}>
      <div className="alert-banner__content">
        {getIcon()}
        <div className="alert-banner__text-wrapper">
          <span className="alert-banner__message">{message}</span>
          {description && (
            <span className="alert-banner__description">{description}</span>
          )}
        </div>
      </div>

      <div className="alert-banner__actions">
        {action && (
          <button
            type="button"
            className="alert-banner__action-btn"
            onClick={action.onClick}
          >
            {action.label}
          </button>
        )}
        {onClose && (
          <button
            type="button"
            className="alert-banner__close"
            onClick={onClose}
            aria-label="Close banner"
          >
            <CloseOutlined />
          </button>
        )}
      </div>
    </div>
  );
};

export default AlertBanner;
